import React from 'react';

const TermsPage = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
      
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-3">Google Account Permissions</h2>
          <p className="text-gray-700">
            By using our email generation feature, you grant us permission to access your Gmail account for the purposes of reading, composing, and sending emails on your behalf. You may revoke this access at any time through your Google account settings.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">User Responsibilities</h2>
          <p className="text-gray-700">
            You are responsible for all activity that occurs under your account. You agree not to use the service for any unlawful or abusive purposes.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">Limitation of Liability</h2>
          <p className="text-gray-700">
            We are not liable for any damages or losses resulting from your use of the service, including but not limited to loss of data or unauthorized access to your account.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">Revoking Permissions</h2>
          <p className="text-gray-700">
            You may revoke our access to your Google account at any time by visiting your Google account permissions page.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">Contact</h2>
          <p className="text-gray-700">
            For questions about these terms, contact us at: support@quislab.com
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsPage; 